import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectAnswer } from '../redux/actions';

class Question extends Component {
  render() {
    return (
      <div className='content'>
        <h1 className='question'>{this.props.questionText}</h1>
        <div className='answers'>
          {
            this.props.answerChoices.map((value, i) => (
                <div key={value.text}>
                  <button
                    className="hidden"
                    name={this.props.questionText} 
                    id={value.text} 
                    value={value.text} 
                    onClick={() => {
                      this.props.onInput(this.props.questionId, value.id);
                      // this is a very rough hack to get around the fact that, 
                      // for some reason, the last answer doesn't register if you
                      // switch routes right away. So instead we just wait for 5 ms.
                      setTimeout(() => {
                        this.props.history.push(this.props.nextRoute);
                      }, 5);
                    }} 
                  />
                  <label htmlFor={value.text}>
                    <div className="Blob Interactive choice">
                      <p>{value.text}</p>
                    </div>
                  </label>
                </div>
              )
            )
          }
        </div>
      </div>
    )
  }
}

export default withRouter(
    connect(null, {
        onInput: selectAnswer,
    })(Question)
);

Question.propTypes = {
  questionId: PropTypes.string,
  questionText: PropTypes.string,
  answerChoices: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
  })),
  onInput: PropTypes.func,
}